import { c as _c } from "react/compiler-runtime";
import { Flex, Button, Text, NativeSelectRoot, NativeSelectField, NativeSelect } from "@chakra-ui/react";
import { defineMessages, useIntl } from "react-intl";
import { formatDateLabel } from "./timePickerUtils";
const messages = defineMessages({
  applyFilter: {
    id: "timePicker.applyFilter",
    defaultMessage: "Apply"
  },
  resetRange: {
    id: "timePicker.resetRange",
    defaultMessage: "Reset"
  },
  noData: {
    id: "timePicker.noData",
    defaultMessage: "No data for the selected time interval"
  }
});
interface TimePickerHeaderProps {
  dateKeys: string[];
  selectedDateKey: string;
  hasDataInRange: boolean;
  onDateChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  onApply: () => void;
  onReset: () => void;
}
export const TimePickerHeader = t0 => {
  const $ = _c(29);
  const {
    dateKeys,
    selectedDateKey,
    hasDataInRange,
    onDateChange,
    onApply,
    onReset
  } = t0;
  const intl = useIntl();
  let t1;
  if ($[0] !== dateKeys) {
    t1 = dateKeys.map(_temp);
    $[0] = dateKeys;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== onDateChange || $[3] !== selectedDateKey || $[4] !== t1) {
    t2 = <NativeSelectField data-testid="time-picker-date-select" value={selectedDateKey} onChange={onDateChange} borderColor="grey.100" borderRadius="button" background="grey.100" color="text">{t1}</NativeSelectField>;
    $[2] = onDateChange;
    $[3] = selectedDateKey;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <NativeSelect.Indicator />;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t2) {
    t4 = <NativeSelectRoot size="sm" width="12.5rem" variant="outline">{t2}{t3}</NativeSelectRoot>;
    $[7] = t2;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== hasDataInRange || $[10] !== intl) {
    t5 = !hasDataInRange && <Text data-testid="time-picker-no-data" fontSize="xs" color="text">{intl.formatMessage(messages.noData)}</Text>;
    $[9] = hasDataInRange;
    $[10] = intl;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== intl) {
    t6 = intl.formatMessage(messages.applyFilter);
    $[12] = intl;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== onApply || $[15] !== t6) {
    t7 = <Button data-testid="time-picker-apply" size="sm" bg="grey.700" color="white" borderRadius="button" fontWeight="semibold" px="6" onClick={onApply}>{t6}</Button>;
    $[14] = onApply;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== intl) {
    t8 = intl.formatMessage(messages.resetRange);
    $[17] = intl;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== onReset || $[20] !== t8) {
    t9 = <Button data-testid="time-picker-reset" size="sm" bg="grey.200" color="text" borderRadius="button" fontWeight="semibold" px="6" onClick={onReset}>{t8}</Button>;
    $[19] = onReset;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== t7 || $[23] !== t9) {
    t10 = <Flex gap="3">{t7}{t9}</Flex>;
    $[22] = t7;
    $[23] = t9;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== t10 || $[26] !== t4 || $[27] !== t5) {
    t11 = <Flex justify="space-between" align="center" gap="4">{t4}{t5}{t10}</Flex>;
    $[25] = t10;
    $[26] = t4;
    $[27] = t5;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  return t11;
};
function _temp(dateKey) {
  return <option key={dateKey} value={dateKey} style={{
    background: "white",
    color: "black"
  }}>{formatDateLabel(dateKey)}</option>;
}